import { ToggleGroup, ToggleGroupButton } from '@compass/components'
import { ampli } from 'models/ampli'

import { useServerApiVersion } from '../../hooks/useServerApiVersion'
import { ServerApiVersion } from '../../types'

export function ServerApiVersionSelector() {
  const { serverApiVersion, setServerApiVersion } = useServerApiVersion()

  return (
    <ToggleGroup
      selectedKeys={[serverApiVersion]}
      onSelectionChange={(keys: Set<ServerApiVersion>) => {
        const version = [...keys][0]
        setServerApiVersion(version)
        ampli.identificationEventDetailsApiVersionSwitched({ ApiVersionJson: version })
      }}
    >
      <ToggleGroupButton id={ServerApiVersion.V3}>v3</ToggleGroupButton>
      <ToggleGroupButton id={ServerApiVersion.V4}>v4</ToggleGroupButton>
    </ToggleGroup>
  )
}
